const ReportContentType = {
    BookSectionCrop: 1,
    AnswerVideo: 2,
    AchievementVideo: 3,
    LectureSection: 4,
};

export default ReportContentType;